var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('span',[_vm._v("Cliente importado do SGV: ")]),_c('strong',[(!_vm.isLoading)?_c('v-chip',{staticClass:"text-uppercase",attrs:{"color":_vm.payload.color,"text-color":_vm.payload.textColor,"label":""}},[_vm._v(" "+_vm._s(_vm.payload.label)+" ")]):_c('v-progress-circular',{attrs:{"color":"primary"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }